import { Identifiable } from "./Identifiable";
import { NotifierDetails } from "./NotifierFormData";
import { AccountDetails } from "@customTypes/NotifierFormData";
import { ServiceProvider } from "@src/pages/NotifierForm/AccountForm/CompanyNameInput";
import { getExpressSectionSourceDataByKey } from "@src/pages/ExpressForm/express-data";
export interface Document extends Identifiable {
  readonly id: string;
  readonly downloadUrl: string;
  readonly filename: string;
  readonly uploadedAt: Date;
  readonly tags?: string[];
}

// either service provider needs a will or role in executor or solcitor will is required

export const isWillRequired = (
  accounts: readonly AccountDetails[] | undefined,
  notifier: NotifierDetails | undefined,
  serviceProvidersMap: Record<string, ServiceProvider>
): boolean => {
  const isExecutor = ["sole_executor", "executor"].includes(notifier?.role ?? "empty_string");

  const isReq = accounts?.some(
    (account: AccountDetails) =>
      account.companyId && serviceProvidersMap[account.companyId]?.willNeeded
  );
  // if no accounts are added then will is required
  const askForWillAndProbate = isReq || isExecutor || accounts?.length === 0;

  return askForWillAndProbate;
};
export const isWillRequiredExpressForm = (serviceProvider: { willNeeded?: boolean }) => {
  // sp does not required will
  if (!!!serviceProvider.willNeeded) return false;

  let notifierInfo: NotifierDetails | undefined = getExpressSectionSourceDataByKey("notifier");
  // notifier details are not provided so will is required
  if (!!!notifierInfo) return true;

  let isExecutor, isAdmin;

  if (typeof notifierInfo.role === "string") {
    isExecutor = ["sole_executor", "executor"].includes(notifierInfo.role);
    // console.log(isExecutor, "isExecutor");

    isAdmin = "administrator" === notifierInfo.role;
  } else {
    isExecutor = false;
    isAdmin = false;
  }

  // if you are a executor you have to provide a will
  if (isExecutor) return true;
  // there is no will
  if (isAdmin) return false;

  return true;
};
